/** Source: public/design-patterns.html B-4a/B-4b. */
type Props = { pattern?: string; num?: string; title?: string; en?: string; tone?: string }
import { decoExists } from '../../lib/images'
export function Chapter({ pattern = 'B-4a', num, title, en, tone = 'none' }: Props) {
  const classes = ['chap', pattern === 'B-4b' && 'light', tone !== 'none' && tone].filter(Boolean).join(' ')
  return <div className={classes}><div className="shell">
    {pattern === 'B-4a' && decoExists('/img/deco/rose_bud_mark_white.png') && <img className="rose-bud" src="/img/deco/rose_bud_mark_white.png" alt="" aria-hidden="true" />}
    {num && <span className="n">{num}</span>}<span className="t">{title}</span>{en && <span className="en">{en}</span>}
  </div></div>
}
